<ng-container [formGroup]="formGroup">
    <ng-container formArrayName="recurringDays">
        <div class="flex-responsive gap-1" *ngFor="let condition of dailyBailConditions.controls; let i=index">
            <ng-container [formGroupName]="i">
                <mat-form-field class="flex-grow">
                    <mat-label>Day</mat-label>
                    <mat-select formControlName="dayOfWeek">
                        <mat-option [value]="Day.Monday">Monday</mat-option>
                        <mat-option [value]="Day.Tuesday">Tuesday</mat-option>
                        <mat-option [value]="Day.Wednesday">Wednesday</mat-option>
                        <mat-option [value]="Day.Thursday">Thursday</mat-option>
                        <mat-option [value]="Day.Friday">Friday</mat-option>
                        <mat-option [value]="Day.Saturday">Saturday</mat-option>
                        <mat-option [value]="Day.Sunday">Sunday</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="flex-grow">
                    <mat-label>Start Time</mat-label>
                    <input matInput type="time" formControlName="startTime">
                </mat-form-field>
                <mat-form-field class="flex-grow">
                    <mat-label>End Time</mat-label>
                    <input matInput type="time" formControlName="endTime">
                </mat-form-field>
                <button mat-flat-button color="warn" type="button" class="aligned-button" matTooltip="Delete"
                    (click)="removeBailCondition(i)" [disabled]="dailyBailConditions.length <= 1">
                    <mat-icon>close</mat-icon>
                </button>
            </ng-container>
        </div>
        <button mat-flat-button class="aligned-button w-full" color="primary" type="button"
                (click)="addBailCondition()">Add another day</button>
    </ng-container>
</ng-container>
